import { render } from "./DoctorHeader.vue?vue&type=template&id=838c9d00&scoped=true&ts=true"
import script from "./DoctorHeader.vue?vue&type=script&lang=ts"
export * from "./DoctorHeader.vue?vue&type=script&lang=ts"

import "./DoctorHeader.vue?vue&type=style&index=0&id=838c9d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838c9d00"]])

export default __exports__